import { client } from ".";

export const getDashboardStats = async (astrologerId, accessToken, period = 'today') => {
  try {
    const response = await client.get(
      `/api/astrologer/dashboard/${astrologerId}?period=${period}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return { status: response.status, data: response.data.data };
  } catch (err) {
    console.error('Error fetching dashboard stats:', err);
    return { status: err.response?.status || 500, error: err.message, data: null };
  }
};

export const updateAstrologer = async (astrologerId, payload, accessToken) => {
  try {
    const { status } = await client.put(
      `/api/astrologer/update/${astrologerId}`,
      payload,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return { status };
  } catch (err) {
    console.log({ err });
  }
};
